export default __webpack_public_path__ + "static/media/pistachios.346c7b22.png";